import { useRef, useState } from "react";
import Logo from "../assets/images/logo (2).svg";
import SmallLogo from "../assets/images/jamb_logo.svg";
import Ham from "../assets/icons/hamburger.svg";
import {
  IoCloseOutline,
  IoNotifications,
  IoNotificationsOutline,
} from "react-icons/io5";
import { GoCheck, GoDotFill, GoHomeFill } from "react-icons/go";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import Home_1 from "../assets/icons/home-active.svg";
import Home_2 from "../assets/icons/home-inactive.svg";
import Brochure_1 from "../assets/icons/brochure-active.svg";
import Brochure_2 from "../assets/icons/brochure-inactive.svg";
import Syllabus_1 from "../assets/icons/syllabus-active.svg";
import Syllabus_2 from "../assets/icons/syllabus-inactive.svg";
import Processes_1 from "../assets/icons/processes-active.svg";
import Processes_2 from "../assets/icons/processes-inactive.svg";
import Materials_1 from "../assets/icons/materials-active.svg";
import Materials_2 from "../assets/icons/materials-inactive.svg";
import CBT_1 from "../assets/icons/cbt-active.svg";
import CBT_2 from "../assets/icons/cbt-inactive.svg";
import Help_1 from "../assets/icons/help-active.svg";
import Help_2 from "../assets/icons/help-inactive.svg";
import { CiBank } from "react-icons/ci";
import { BsBook } from "react-icons/bs";
import { HiOutlineBookmarkSquare } from "react-icons/hi2";
import { LuMousePointerClick } from "react-icons/lu";
import { HiOutlineClipboardList } from "react-icons/hi";
import { HiOutlineChatBubbleLeftRight } from "react-icons/hi2";
import { MdOutlineStickyNote2 } from "react-icons/md";
import { BsArrowUpRight } from "react-icons/bs";
import Programme from "../assets/icons/programme.svg";
import Website from "../assets/icons/website.svg";
import Facility from "../assets/icons/facility.svg";
import Hide from "../assets/icons/open.svg";
import Modal from "../components/modals/Modal";
import Contact from "../components/modals/Contact";
import { motion } from "framer-motion";
import { SlArrowRight } from "react-icons/sl";
import { Link } from "react-router-dom";

const DashboardLayout = ({
  children,
  overview,
  brochure,
  eSyllabus,
  processes,
  materials,
  cbt,
  help,
  childTab,
  animated,
}) => {
  const [open, setOpen] = useState(false);
  const [hide, setHide] = useState(false);
  // const [tab, setTab] = useState(1);
  const [child, setChild] = useState(childTab);

  const [dropdown, setDropdown] = useState(false);
  const [not, setNot] = useState(false);

  const [openContact, setOpenContact] = useState(false);

  const tabs = [
    {
      id: 1,
      name: "Dashboard",
      link: "/",
      present: overview,
      inactive: Home_2,
      active: Home_1,
    },
    {
      id: 2,
      name: "Brochure",
      link: "/brochure-by-institution",
      present: brochure,
      inactive: Brochure_2,
      active: Brochure_1,
      children: [
        {
          id: 11,
          name: "View by institution",
          link: "/brochure-by-institution",
          present: brochure,
          icon: <CiBank className="text-[21px] xl:text-[27px]" />,
        },
        {
          id: 12,
          name: "View by programme  (PDF)",
          link: "/brochure-by-programme",
          present: brochure,
          icon: <BsBook className="text-[16px] xl:text-[21px]" />,
        },
      ],
    },
    {
      id: 3,
      name: "E-syllabus",
      link: "/e-syllabus",
      present: eSyllabus,
      inactive: Syllabus_2,
      active: Syllabus_1,
      children: [
        {
          id: 11,
          name: "All Subjects",
          icon: (
            <HiOutlineBookmarkSquare className="text-[21px] xl:text-[25px]" />
          ),
        },
      ],
    },
    {
      id: 4,
      name: "Processes",
      link: "/processes",
      present: processes,
      inactive: Processes_2,
      active: Processes_1,
    },
    {
      id: 5,
      name: "Materials",
      link: "/materials",
      present: materials,
      inactive: Materials_2,
      active: Materials_1,
      children: [
        {
          id: 11,
          name: "Books recommendations",
          icon: <BsBook className="text-[16px] xl:text-[21px]" />,
        },
      ],
    },
    {
      id: 6,
      name: "CBT",
      link: "/cbt",
      present: cbt,
      inactive: CBT_2,
      active: CBT_1,
      children: [
        {
          id: 11,
          name: "CBT without mouse",
          icon: <LuMousePointerClick className="text-[18px] xl:text-[23px]" />,
        },
      ],
    },
    {
      id: 7,
      name: "Help",
      link: "/help",
      present: help,
      inactive: Help_2,
      active: Help_1,
      children: [
        {
          id: 11,
          name: "How to",
          link: "/help",
          present: help,
          icon: (
            <HiOutlineClipboardList className="text-[18px] xl:text-[23px]" />
          ),
        },
        {
          id: 12,
          name: "Frequently asked questions",
          link: "/faq",
          present: help,
          icon: (
            <HiOutlineChatBubbleLeftRight className="text-[18px] xl:text-[23px]" />
          ),
        },
        {
          id: 13,
          name: "Correction of data",
          link: "/correction",
          present: help,
          icon: <MdOutlineStickyNote2 className="text-[18px] xl:text-[23px]" />,
        },
      ],
    },
  ];

  const handleTab = (item) => {
    // setTab(item);
    setChild(11);
    setHide(false);
  };

  const handleChild = (item) => {
    setChild(item);
    setOpen(false);
  };

  // const handleDropdown = () => {
  //     setDropdown(!dropdown)
  // }

  const handleViewAll = () => {
    setChild(14);
    setDropdown(false);
  };

  const handleOpen = () => {
    setNot(true);
    setDropdown(true);
  };

  const handleClose = () => {
    if (child !== 14) {
      setNot(false);
      setDropdown(false);
    } else {
      return;
    }
  };

  const hasAnimated = useRef(animated);

  return (
    <div className="flex flex-col items-center w-full h-full lg:overflow-y-hidden lg:h-screen">
      <div className="flex flex-col items-center justify-start w-full h-full font-inter lg:flex-row lg:items-start">
        {/* LEFT CONTENT */}
        <div
          className={`no-scrollbar flex flex-col items-start justify-start w-full h-full shadow-md bg-white px-5 md:px-10 lg:flex-col lg:justify-start lg:px-0 lg:w-64 lg:h-screen
                      lg:overflow-y-auto lg:relative lg:pb-20 lg:items-start xl:w-[350px] ${
                        hide &&
                        "lg:w-[90px] lg:overflow-hidden lg:px-0 xl:w-[8.5%]"
                      }`}
        >
          <div
            className={`flex items-center justify-between w-full h-20 lg:px-6 lg:pt-3 lg:h-[62px] xl:px-8 xl:pt-0 xl:h-32 xl:pb-16 
                             ${
                               hide &&
                               "lg:px-[20px] lg:pt-[10px] xl:px-[10px] xl:justify-center xl:pt-[25px]"
                             }`}
          >
            {hide ? (
              <img
                className="lg:flex lg:w-80 lg:h-80 xl:w-12 xl:mb-[10px]"
                src={SmallLogo}
                alt="ibass_logo"
              />
            ) : (
              <img
                className="w-28 md:w-32 lg:w-24 xl:w-24"
                src={Logo}
                alt="ibass_logo"
              />
            )}

            {/* MOBILE HAMBURGER */}
            {open ? (
              <IoCloseOutline
                onClick={() => setOpen(false)}
                className="text-4xl text-[#53545C] lg:hidden"
              />
            ) : (
              <img
                onClick={() => setOpen(true)}
                className="h-6 w-6 md:w-6 lg:hidden"
                src={Ham}
                alt="ibass_logo"
              />
            )}

            {/* DESKTOP HAMBURGER */}
            {!hide && (
              <img
                onClick={() => setHide(!hide)}
                className="hidden lg:flex h-[18px] w-[18px]"
                src={Hide}
                alt="ibass_logo"
              />
            )}
          </div>

          {/* TABS CONTAINER */}
          <div
            className={`absolute top-20 left-0 flex flex-col items-start justify-start w-[60%] h-full bg-white shadow-2xl z-30 pt-4 pb-10 md:w-[35%] 
                             lg:pt-6 lg:top-[60px] lg:h-screen lg:pb-2 lg:w-full xl:pt-[10px] ${
                               hide && "lg:pb-7"
                             } ${!open && "hidden lg:flex xl:flex"}`}
          >
            {tabs.map((item) => (
              <motion.div
                //  transition={{ duration: 0.5, delay: item.id * 0.2, easing: "easeOut", }}
                initial={{ scale: 1, opacity: 1 }}
                animate={
                  !hasAnimated.current
                    ? {
                        scale: 1,
                        opacity: [0, 0.1, 0.3, 0.5, 1.0],
                        y: ["100%", "0%"],
                      }
                    : { scale: 1, opacity: 1 }
                }
                transition={{
                  duration: 0.5,
                  delay: item.id * 0.2,
                  ease: "easeOut",
                }}
                onAnimationComplete={() => {
                  // Mark animation as complete after it runs
                  hasAnimated.current = true;
                }}
                key={item.id}
                className={`w-full px-5 lg:px-6 xl:px-9 ${
                  hide && "lg:px-[16px] xl:px-[20px]"
                }`}
              >
                <Link
                  to={item?.link}
                  onClick={() => handleTab(item.id)}
                  className={`flex items-center justify-between w-full h-10 rounded-[10px] px-4 mt-4 cursor-pointer lg:mt-2 xl:h-12 ${
                    item.present && "bg-[#25A249]"
                  } 
                                    ${!item.present && "hover:bg-[#e5fceb]"} ${
                    hide &&
                    "rounded-[8px] lg:justify-center mt-[10px] px-0 xl:rounded-[10px]"
                  }`}
                >
                  <div
                    className={`flex items-center justify-start w-full ${
                      hide && "justify-center"
                    }`}
                  >
                    <img
                      className={`w-[18px] h-[18px] xl:w-[22px] xl:h-[22px]`}
                      src={item.present ? item.active : item.inactive}
                      alt="home_inactive"
                    />
                    <p
                      className={`text-[11px] font-normal text-[#53545C] ml-4 xl:text-sm xl:ml-5 ${
                        item.present && "text-[#ffffff]"
                      }  ${hide && "lg:hidden"}`}
                    >
                      {item.name}
                    </p>
                  </div>
                  {item.present && item.id !== 1 ? (
                    <IoIosArrowUp
                      className={`text-xs text-[#ffffff] xl:text-base ${
                        hide && "lg:hidden"
                      }`}
                    />
                  ) : (
                    item.id !== 1 && (
                      <IoIosArrowDown
                        className={`text-xs text-[#101828] xl:text-base ${
                          hide && "lg:hidden"
                        }`}
                      />
                    )
                  )}
                </Link>

                {item.present && item.children && (
                  <div
                    className={`flex flex-col items-start justify-start w-full rounded-lg px-4 ${
                      hide && "lg:hidden"
                    }`}
                  >
                    {item.children.map((item) => (
                      <Link
                        to={item?.link}
                        onClick={() => handleChild(item.id)}
                        key={item.id}
                        className="flex items-center justify-start mt-4 cursor-pointer"
                      >
                        <div
                          className={`${
                            child === item?.id
                              ? "text-[#25A249]"
                              : "text-[#53545C]"
                          }`}
                        >
                          {item.icon}
                        </div>
                        <p
                          className={`text-[10px] font-normal ml-4 xl:text-[13px] xl:ml-5 ${
                            child === item?.id
                              ? "text-[#25A249]"
                              : "text-[#53545C]"
                          }`}
                        >
                          {item.name}
                        </p>
                      </Link>
                    ))}
                  </div>
                )}
              </motion.div>
            ))}

            {/* LINE */}
            <div className="flex border-[1px] w-full border-[#DDE1E6] mt-10 xl:mt-16"></div>

            <div
              className={`px-5 cursor-pointer lg:flex flex-col items-start justify-start pb-8 mt-5 w-full bg-white lg:px-6 lg:mb-10 xl:px-9 xl:mt-7 ${
                hide && "lg:items-center lg:mt-9"
              }`}
            >
              <div
                className={`flex items-center justify-start w-full ${
                  hide && "hidden"
                }`}
              >
                <p className="text-[13px] text-[#53545C] font-semibold xl:text-[15px]">
                  WEBSITES
                </p>
                <BsArrowUpRight className="ml-1 text-[#808080] xl:ml-[6px]" />
              </div>

              <a
                href="/eligibility-checker"
                // target="_blank"
                // rel="noreferrer"
                className={`flex items-center justify-start mt-6 ${
                  hide && "mt-0 justify-center"
                }`}
              >
                <img
                  className="w-[18px] h-[18px] xl:w-[22px] xl:h-[22px]"
                  src={Programme}
                  alt="programme"
                />
                <p
                  className={`text-[12px] font-normal ml-4 text-[#53545C] xl:text-sm ${
                    hide && "hidden"
                  }`}
                >
                  Check programme eligibility
                </p>
              </a>

              <a
                href="https://www.jamb.gov.ng"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-start mt-8"
              >
                <img
                  className="w-[18px] h-[18px] xl:w-[22px] xl:h-[22px]"
                  src={Website}
                  alt="programme"
                />
                <p
                  className={`text-[10px] font-normal ml-4 text-[#53545C] xl:text-sm ${
                    hide && "hidden"
                  }`}
                >
                  JAMB website
                </p>
              </a>

              <a
                href="https://efacility.jamb.gov.ng"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-start mt-8"
              >
                <img
                  className="w-[18px] h-[18px] xl:w-[22px] xl:h-[22px]"
                  src={Facility}
                  alt="programme"
                />
                <p
                  className={`text-[11px] font-normal ml-4 text-[#53545C] xl:text-sm ${
                    hide && "hidden"
                  }`}
                >
                  E-facility
                </p>
              </a>
            </div>
          </div>
        </div>

        {/*CONTENTS */}
        <div
          onClick={() => setOpen(false)}
          className={`flex flex-col items-center justify-start w-full h-full overflow-y-auto lg:relative ${
            open && "overflow-y-hidden h-screen"
          }`}
        >
          {/*DESKTOP ONLY */}
          <div
            className="hidden lg:flex items-center justify-between w-full h-[62px] px-8 pt-8 pb-2 border-0 border-[#F1F3F9] border-l-2 
                              border-b-2 xl:pt-9 xl:pb-5"
          >
            <div className="flex items-center justify-start">
              {hide && (
                <img
                  onClick={() => setHide(!hide)}
                  className="hidden lg:flex h-[20px] w-[20px] z-50 xl:h-[18px] xl:w-[18px]"
                  src={Ham}
                  alt="ibass_logo"
                />
              )}
              <p className="text-sm text-[#53545C] font-semibold lg:ml-4">
                {overview ||
                  brochure ||
                  eSyllabus ||
                  processes ||
                  materials ||
                  cbt ||
                  help}
              </p>
            </div>

            <div className="flex items-encenterd justify-start mb-3.5">
              {/* <img className='w-4 xl:w-5' 
                     src={Bell} alt='notification_icon' /> */}

              {!not && child !== 14 && (
                <IoNotificationsOutline
                  onClick={() => handleOpen()}
                  className="text-[#101828] text-xl mt-1.5 xl:mt-2.5 xl:text-[23px]"
                />
              )}

              {(not || child === 14) && (
                <IoNotifications
                  onClick={() => handleClose()}
                  className="text-[#25A249] text-xl mt-1.5 xl:mt-2.5 xl:text-[23px]"
                />
              )}

              <button
                onClick={() => setOpenContact(true)}
                className="text-[11px] text-[#ffffff] bg-[#25A249] ml-9 font-normal py-2 px-4 rounded-md xl:ml-11 xl:text-[14px] xl:py-2.5 xl:px-6 xl:rounded-[10px]"
              >
                Contact us
              </button>
            </div>
          </div>

          <div className="flex items-center justify-between w-full px-5 pb-1 md:pb-1.5 md:px-6 lg:px-7 xl:px-10 xl:pb-2">
            <div className="flex items-center justify-start mt-3 xl:mt-4">
              <Link
                to="/"
                className="flex items-end justify-start cursor-pointer"
              >
                <GoHomeFill
                  className={`${
                    overview ? "text-[#25A249]" : "text-[#667085]"
                  } text-base`}
                />
                <p
                  className={`text-[10px] ml-2 font-medium lg:text-[11px] xl:text-xs ${
                    overview ? "text-[#25A249]" : "text-[#667085]"
                  }`}
                >
                  Dashboard
                </p>
              </Link>
              {!overview && (
                <div className="flex items-end justify-start">
                  <p
                    className={`text-xs ml-2 font-semibold -mb-[2px] text-[#667085]`}
                  >
                    /
                  </p>
                  <p
                    className={`text-[10px] ml-2 font-medium -mb-[3px] text-[#25A249] xl:text-xs`}
                  >
                    {overview ||
                      brochure ||
                      eSyllabus ||
                      processes ||
                      materials ||
                      cbt ||
                      help}
                  </p>
                </div>
              )}
            </div>

            {/*MOBILE ONLY */}
            <div className="flex items-end justify-start mt-3 lg:hidden">
              {/* <img className='w-4' 
                     src={Bell} alt='notification_icon' /> */}

              {!not && child !== 14 && (
                <IoNotificationsOutline
                  onClick={() => handleOpen()}
                  className="text-[#101828] text-[17px] md:text-lg"
                />
              )}

              {(not || child === 14) && (
                <IoNotifications
                  onClick={() => handleClose()}
                  className="text-[#25A249] text-[17px] md:text-lg"
                />
              )}

              <p
                onClick={() => setOpenContact(true)}
                className="text-[10px] text-[#25A249] ml-3.5 font-medium -mb-[2px]"
              >
                Contact us
              </p>
            </div>
          </div>

          {dropdown && (
            <div
              className="absolute flex flex-col items-center w-[90%] z-40 bg-white shadow-2xl rounded-lg border-[1px] border-[#dddddd] rounded-tr-none mt-9 px-3.5 py-4 md:w-[52%] md:right-24 
                             md:mt-10 md:py-6 lg:w-[55%] lg:mt-16 lg:right-40 lg:px-4 xl:w-[35%] xl:mt-16 xl:right-48"
            >
              <div className="flex items-center justify-between w-full">
                <p className="text-[#1C1D22] text-xs font-medium">
                  Notifications
                </p>

                <div
                  onClick={() => handleViewAll()}
                  className="flex items-center justify-end cursor-pointer"
                >
                  <p className="text-[#25A249] text-[10px] font-medium">
                    View All
                  </p>
                  <SlArrowRight className="text-[9px] text-[#25A249] ml-1.5" />
                </div>
              </div>

              <div className="flex flex-col items-start w-full">
                <div className="flex flex-col items-start w-full mt-3 md:mt-6">
                  <p className="text-[10px] text-[#667085] font-light py-4">
                    This Week
                  </p>

                  <div className="flex items-center justify-start w-full">
                    <div className="flex items-center justify-start">
                      <GoDotFill className="text-[#DA1E28] text-[11px]" />
                      <div className="h-7 w-7 flex items-center justify-center rounded-full bg-[#DCF0E2] ml-3">
                        <GoCheck className="text-[#25A249] text-base md:text-lg" />
                      </div>
                    </div>

                    <div className="flex flex-col items-start justify-start ml-4 w-full ">
                      <p className="text-[11px] text-[#101828] font-normal md:text-xs">
                        Message from the Registrar
                      </p>
                      <p className="text-[10px] text-[#667085] font-light pt-0.5 md:text-[11px]">
                        2min ago
                      </p>
                    </div>
                  </div>
                  {/* HORIZONTAL LINE */}
                  <hr className="w-full mt-3.5" />
                </div>

                <div className="flex flex-col items-start w-full mt-3 md:mt-6">
                  <div className="flex items-center justify-start w-full">
                    <div className="flex items-center justify-start">
                      <GoDotFill className="text-[#DA1E28] text-[11px]" />
                      <div className="h-7 w-7 flex items-center justify-center rounded-full bg-[#DCF0E2] ml-3">
                        <GoCheck className="text-[#25A249] text-base" />
                      </div>
                    </div>

                    <div className="flex flex-col items-start justify-start ml-4 w-full">
                      <p className="text-[11px] text-[#101828] font-normal md:text-xs">
                        Paraded for attempting to write the UTME for his
                        brother.
                      </p>
                      <p className="text-[10px] text-[#667085] font-light pt-0.5 md:text-[11px]">
                        1h ago
                      </p>
                    </div>
                  </div>
                  {/* HORIZONTAL LINE */}
                  <hr className="w-full mt-3.5" />
                </div>

                <div className="flex flex-col items-start w-full mt-3 md:mt-6">
                  <div className="flex items-center justify-start w-full">
                    <div className="flex items-center justify-start">
                      <GoDotFill className="text-[#DA1E28] text-[11px]" />
                      <div className="h-7 w-7 flex items-center justify-center rounded-full bg-[#DCF0E2] ml-3">
                        <GoCheck className="text-[#25A249] text-base" />
                      </div>
                    </div>

                    <div className="flex flex-col items-start justify-start ml-4 w-full">
                      <p className="text-[11px] text-[#101828] font-normal md:text-xs">
                        Director of Admissions
                      </p>
                      <p className="text-[10px] text-[#667085] font-light pt-0.5 md:text-[11px]">
                        11h ago
                      </p>
                    </div>
                  </div>
                  {/* HORIZONTAL LINE */}
                  <hr className="w-full mt-3.5" />
                </div>

                <div className="flex flex-col items-start w-full mt-3 md:mt-6">
                  <p className="text-[10px] text-[#667085] font-light py-4">
                    Last Week
                  </p>

                  <div className="flex items-center justify-start w-full">
                    <div className="flex items-center justify-start">
                      <GoDotFill className="text-[#DA1E28] text-[11px]" />
                      <div className="h-7 w-7 flex items-center justify-center rounded-full bg-[#DCF0E2] ml-3">
                        <GoCheck className="text-[#25A249] text-base" />
                      </div>
                    </div>

                    <div className="flex flex-col items-start justify-start ml-4 w-full">
                      <p className="text-[11px] text-[#101828] font-normal md:text-xs">
                        Director of Admissions
                      </p>
                      <p className="text-[10px] text-[#667085] font-light pt-0.5 md:text-[11px]">
                        19/05/2023
                      </p>
                    </div>
                  </div>
                  {/* HORIZONTAL LINE */}
                  <hr className="w-full mt-3.5" />
                </div>
              </div>
            </div>
          )}

          {children}

          {openContact && (
            <Modal onClick={() => setOpenContact(false)}>
              <Contact setModal={setOpenContact} />
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
